




























import Vue from 'vue';
import Component from 'vue-class-component';
import NavBar from '../components/NavBar';
import Footer from '@/components/Footer.vue';
import PrivacyPoliceApi from '@/api/privacy-police.api';
import { PrivacyPoliceModel } from '@/models/privacy-police.model';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LocaleSelectorType } from '@/store/i18n.store.module';
import { i18nModule, i18nState } from '@/utils/store-acessor';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    NavBar,
    Footer
  },
  metaInfo() {
    return {
      title: 'Ikone'
    };
  },
})
export default class PrivacyPolicy extends Vue {
  @i18nModule.Getter('locale') selected!: LocaleSelectorType;

  privacyPolice: string = '';
  loading?: boolean = true;
  response = new PrivacyPoliceModel();

  async mounted() {
    await new PrivacyPoliceApi()
      .getPrivacyPolice()
      .pipe(take(1))
      .subscribe(response => {
        this.response = response;
        this.loading = false;
        if (this.selected.value === 'en') {
          this.privacyPolice = `${response?.value?.en}`;
        } else {
          this.privacyPolice = `${response?.value?.pt}`;
        }
      });
  }

  @Watch('selected')
  onLocaleSelected(v: LocaleSelectorType) {
    if (v.value === 'en') {
      this.privacyPolice = `${this.response?.value?.en}`;
    } else {
      this.privacyPolice = `${this.response?.value?.pt}`;
    }
  }
}
